import { render, staticRenderFns } from "./compInfoConfig.vue?vue&type=template&id=7e335b6e&scoped=true"
import script from "./compInfoConfig.vue?vue&type=script&lang=js"
export * from "./compInfoConfig.vue?vue&type=script&lang=js"
import style0 from "./compInfoConfig.vue?vue&type=style&index=0&id=7e335b6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e335b6e",
  null
  
)

export default component.exports